import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.content}/v4/products`, {
  get: {
    'product.getProductsByProducer': '/',
    'product.getHotlinksByProducerAndProduct': '/:id/hotlinks',
    'product.getOffersByProduct': '/:id/offers'
  }
});

Request.register(`${Settings.api.marketplace}/product`, {
  get: {
    'product.getProductById': '/:id'
  }
});
